module.exports = __webpack_public_path__ + "img/m2g_how.36a24d30.png";